<template>
    
<div class="row">
    <div class="col-md-12 text-center module-card" >
        <div class="blog-entry-sports ">
         <p></p>
            <div class="desc" >
                <h1 class="head-article" v-html="languageData['keyword'+id_cloudword]"></h1>
                    <div class="side animate-box">                        
                        <p>
                            <ul class="category">
                                <li v-for="(content,k) in main_content" :key="k">
                                    <router-link :to="'/content/'+content['id_cr']" v-html="content['title']" >
                                    </router-link>
                                </li>            
                            </ul>
                        </p>
                    </div> 
            </div>
        </div>
    </div>
</div>

</template>

<script>
import axios from 'axios';

export default {
    name: 'mainContent',
    data(){
        return{
            main_content:[],
            CONTENT_DOMAIN:this.$store.state.CONTENT_DOMAIN,
            id_cloudword:''
            
        };
        
    },
    computed:{
        languageData(){return this.$store.state.languageData;},
    },
    mounted :function(){
        this.showContent()
	},
	methods:{
      showContent(){
          this.id_cloudword=this.$route.params.id_cloudword
          var api_private_key=this.get_api_key_mix('clst')
          axios.get(this.$store.state.apiUrl+'/cloud_content_list',{
              params:{
                  id_cloudword:this.id_cloudword,
                  id_eap:this.$store.state.companyData['id_eap'],
                  id_company:this.$store.state.companyData['id_company'],
                  id_language:this.$store.state.companyData['id_language'],
                  privatekey:api_private_key                  
              }
          })
          .then(response => {              
                response = response.data
                //console.log(response);
                this.main_content = response
                //this.$parent.content_ld_flag=false
                //this.$emit('content_ld_flag_changed');                
                this.$nextTick(function () {
                
                })
              
          })
          .catch((error) => {
                this.main_content = [];
                this.customErrorHandler(error.response.status);
          });
      }

    }
};
</script>
<style scoped>
.content-top-btm-space{
    padding: 55px 0;
}
/*h2{color: #276d96c7;}*/
.module-card{
    padding: 0 5px 5px 20px;
    text-align: left !important;            
}
.side .category li a {
    border-bottom: 1px solid #e0e0e014 !important;
}
</style>
